import { CatHeading } from '@blocks-react/components/Heading';
import { ComponentProps, FC, PropsWithChildren } from 'react';
type CatHeadingProps = ComponentProps<typeof CatHeading>;

export const RequestServiceCalenderInfo: FC<
  PropsWithChildren<CatHeadingProps>
> = ({ children, ...headingProps }) => (
  <CatHeading variant="footnote" {...headingProps}>
    {children}
  </CatHeading>
);
